import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import {
    addToolbarToDropdown,
    createDropdown
} from '@ckeditor/ckeditor5-ui';
import { ButtonView } from '@ckeditor/ckeditor5-ui';

export default class CustomSelect extends Plugin {
    init() {
        const editor = this.editor;
        const options = editor.config.get('customSelect.options') || [];
        const label = editor.config.get('customSelect.label') || 'Selecione uma opção';

        editor.ui.componentFactory.add('customSelect', locale => {

            const buttonsCreator = () => {
                const buttons = [];
                for (let option of options) {
                    const button = new ButtonView();
                    button.set({
                        label: option.label,
                        customValue: option.value,
                        withText: true
                    });

                    button.on('execute', () => {
                        editor.model.change(writer => {
                            //Change the model using the model writer
                            const valueToInsert = button.customValue;

                            //Insert the text at the user's current position
                            editor.model.insertContent(writer.createText(valueToInsert));
                        });
                    });
                    // Either create a new ButtonView instance or create existing.
                    buttons.push(button);
                }
                return buttons;
            };

            // Usa as opções fornecidas no construtor

            const dropdown = createDropdown(locale);
            dropdown.buttonView.set({
                label: label,
                withText: true
            });

            
            const createdButtons = buttonsCreator(); // Obtenha os botões criados.
            addToolbarToDropdown(dropdown, createdButtons, { isVertical: true });


            return dropdown;
        });
    }
}
